import { MODEL_PRICES, withResolvedCacheRates, type ModelPricing } from "@quovy/usage";

export const AGENT_MODEL_REGISTRY = {
  defaultModel: "claude-haiku-4-5",
  models: {
    // Deprecated because Anthropic serves the Fable line only with 30-day data
    // retention, which our zero-data-retention requirement rules out.
    "claude-fable-5": {
      label: "Claude Fable 5",
      provider: "anthropic",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      deprecated: true,
    },
    "claude-haiku-4-5": {
      label: "Claude Haiku 4.5",
      provider: "anthropic",
      contextWindow: 200_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-haiku-5-5": {
      label: "Claude Haiku 5.5",
      provider: "anthropic",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-opus-4-6": {
      label: "Claude Opus 4.6",
      provider: "anthropic",
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-opus-4-7": {
      label: "Claude Opus 4.7",
      provider: "anthropic",
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-opus-4-8": {
      label: "Claude Opus 4.8",
      provider: "anthropic",
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-opus-5": {
      label: "Claude Opus 5",
      provider: "anthropic",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-opus-5-5": {
      label: "Claude Opus 5.5",
      provider: "anthropic",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-sonnet-4-6": {
      label: "Claude Sonnet 4.6",
      provider: "anthropic",
      contextWindow: 200_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-sonnet-5": {
      label: "Claude Sonnet 5",
      provider: "anthropic",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "claude-sonnet-5-5": {
      label: "Claude Sonnet 5.5",
      provider: "anthropic",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-4o": {
      label: "GPT-4o",
      provider: "openai",
      contextWindow: 128_000,
      deprecated: true,
      sunsetAt: "2027-01-14",
    },
    "gpt-4o-mini": {
      label: "GPT-4o Mini",
      provider: "openai",
      contextWindow: 128_000,
      deprecated: true,
      sunsetAt: "2027-01-14",
    },
    "gpt-5": {
      label: "GPT-5",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
      deprecated: true,
      sunsetAt: "2026-12-11",
    },
    "gpt-5-mini": {
      label: "GPT-5 Mini",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
      deprecated: true,
      sunsetAt: "2026-12-11",
    },
    "gpt-5.4": {
      label: "GPT-5.4",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.4-mini": {
      label: "GPT-5.4 Mini",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.4-nano": {
      label: "GPT-5.4 Nano",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
      deprecated: true,
      sunsetAt: "2027-04-01",
    },
    "gpt-5.4-pro": {
      label: "GPT-5.4 Pro",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.5": {
      label: "GPT-5.5",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.5-pro": {
      label: "GPT-5.5 Pro",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.6-sol": {
      label: "GPT-5.6 Sol",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.6-terra": {
      label: "GPT-5.6 Terra",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5.6-luna": {
      label: "GPT-5.6 Luna",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-5-nano": {
      label: "GPT-5 Nano",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 400_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
      deprecated: true,
      sunsetAt: "2026-12-11",
    },
    "gpt-6-astra": {
      label: "GPT-6 Astra",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_050_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-6-sol": {
      label: "GPT-6 Sol",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_050_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-6-luna": {
      label: "GPT-6 Luna",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_050_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-6.1-sol": {
      label: "GPT-6.1 Sol",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_050_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    "gpt-6.1-terra": {
      label: "GPT-6.1 Terra",
      provider: "openai",
      reasonsByDefault: true,
      contextWindow: 1_050_000,
      supportsWebSearch: true,
      supportsComputerUse: true,
    },
    // xAI retired grok-4, grok-4-fast and grok-code-fast-1 on 2026-05-15. The ids
    // still answer, served and billed as grok-4.3 or grok-build-0.1.
    "grok-4": {
      label: "Grok 4",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 256_000,
      deprecated: true,
      sunsetAt: "2026-05-15",
    },
    "grok-4-fast": {
      label: "Grok 4 Fast",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 256_000,
      deprecated: true,
      sunsetAt: "2026-05-15",
    },
    "grok-4.3": {
      label: "Grok 4.3",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
    },
    "grok-4.5": {
      label: "Grok 4.5",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 500_000,
    },
    "grok-4.6": {
      label: "Grok 4.6",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 500_000,
    },
    "grok-4.7": {
      label: "Grok 4.7",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 500_000,
    },
    "grok-build-0.1": {
      label: "Grok Build 0.1 (Beta)",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 256_000,
    },
    "grok-code-fast-1": {
      label: "Grok Code Fast 1",
      provider: "xai",
      reasonsByDefault: true,
      contextWindow: 256_000,
      deprecated: true,
      sunsetAt: "2026-05-15",
    },
    // Quovy retires these older choices for new selections; saved references still resolve.
    "gemini-3-flash-preview": {
      label: "Gemini 3 Flash (Preview)",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      deprecated: true,
    },
    // NB: gemini-3.1-flash-lite-preview is deliberately NOT a catalog entry.
    // The preview model shut down 2026-05-25; it lives on only as a
    // LEGACY_MODEL_ALIASES rewrite to gemini-3.1-flash-lite. (It briefly was
    // both, which made the catalog entry unreachable — the alias is applied
    // before every lookup — while still being selectable at publish time.)
    "gemini-3.1-flash-lite": {
      label: "Gemini 3.1 Flash Lite",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      deprecated: true,
      sunsetAt: "2027-05-07",
    },
    "gemini-3.1-pro-preview": {
      label: "Gemini 3.1 Pro (Preview)",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_048_576,
      supportsWebSearch: true,
    },
    "gemini-3.1-pro-preview-customtools": {
      label: "Gemini 3.1 Pro Custom Tools (Preview)",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_048_576,
      supportsWebSearch: true,
    },
    "gemini-3.5-flash": {
      label: "Gemini 3.5 Flash",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      deprecated: true,
    },
    // Two GA Gemini Flash models from Google's 2026-07-21 launch. Cache-read
    // follows the standard Flash 90% cached-input discount (10% of input); the
    // launch post published input/output only.
    //
    // computer use is intentionally NOT enabled. Google announces a built-in
    // computer-use tool for these, but our runtime would only reach it through
    // the generic function tool in computer-use.ts, whose action vocabulary is
    // Anthropic's — non-Anthropic models drive it poorly (Gemini thrashes and
    // never finishes; measured against Anthropic-native, which completes). Gemini
    // computer use waits for the native Interactions-API path, not this fallback.
    //
    // Flash Cyber from the same post is omitted: a limited-access CodeMender
    // pilot for governments, not a routable GA model.
    "gemini-3.5-flash-lite": {
      label: "Gemini 3.5 Flash Lite",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
    },
    "gemini-3.6-flash": {
      label: "Gemini 3.6 Flash",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
    },
    "gemini-3.7-flash": {
      label: "Gemini 3.7 Flash",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_000_000,
      supportsWebSearch: true,
      deprecated: true,
    },
    // Computer use stays disabled until Quovy supports Google's native protocol.
    "gemini-3.8-flash": {
      label: "Gemini 3.8 Flash",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_048_576,
      supportsWebSearch: true,
    },
    // Google lists computer use for Argon as a preview tool; it stays disabled
    // for the same reason as the Flash line above.
    "gemini-4-argon": {
      label: "Gemini 4 Argon",
      provider: "google",
      reasonsByDefault: true,
      contextWindow: 1_048_576,
      supportsWebSearch: true,
    },
  },
} as const;

const DEFAULT_CONTEXT_WINDOW = 200_000;

export type AgentModelId = keyof typeof AGENT_MODEL_REGISTRY.models;

const LEGACY_MODEL_ALIASES = {
  // Not legacy: OpenAI documents `gpt-5.6` as an alias that routes to the
  // Sol tier, so the bare id must resolve even though only the tiered ids
  // are catalog entries.
  "gpt-5.6": "gpt-5.6-sol",
  "claude-haiku-4-5-20251001": "claude-haiku-4-5",
  "claude-sonnet-4": "claude-sonnet-4-6",
  "claude-sonnet-4-5": "claude-sonnet-4-6",
  "claude-sonnet-4-20250514": "claude-sonnet-4-6",
  "claude-opus-4-5": "claude-opus-4-6",
  "claude-opus-4-1-20250805": "claude-opus-4-8",
  "gemini-3.1-flash-lite-preview": "gemini-3.1-flash-lite",
} as const;

export function normalizeAgentModelId(modelId: string): string {
  const providerStripped = modelId.includes("/") ? (modelId.split("/").pop() ?? modelId) : modelId;
  return (
    LEGACY_MODEL_ALIASES[providerStripped as keyof typeof LEGACY_MODEL_ALIASES] ?? providerStripped
  );
}

/** Look up the canonical price card after provider-prefix and alias normalization. */
export function modelPricing(modelId: string): ModelPricing | null {
  const normalized = normalizeAgentModelId(modelId);
  const pricing = (MODEL_PRICES as Record<string, ModelPricing | undefined>)[normalized];
  const model = (AGENT_MODEL_REGISTRY.models as Record<string, { provider: string } | undefined>)[
    normalized
  ];
  if (!pricing || !model) return null;
  return withResolvedCacheRates(pricing, { provider: model.provider, pricing });
}

export function getAgentModelInfo(modelId: string):
  | ({
      modelId: string;
      provider: string;
      label: string;
      supportsWebSearch?: boolean;
      supportsComputerUse?: boolean;
      contextWindow?: number;
      deprecated?: true;
      sunsetAt?: string;
    } & ModelPricing)
  | null {
  const registry = AGENT_MODEL_REGISTRY.models as Record<
    string,
    {
      label: string;
      provider: string;
      contextWindow?: number;
      supportsWebSearch?: boolean;
      supportsComputerUse?: boolean;
      // Lifecycle soft state: deprecated models keep resolving (existing
      // references are never broken) but new references are rejected at
      // write time. `sunsetAt` (YYYY-MM-DD) is advisory — surfaced in lint
      // warnings and UI badges, never an automatic shutoff.
      deprecated?: true;
      sunsetAt?: string;
    }
  >;
  const normalized = normalizeAgentModelId(modelId);
  const model = registry[normalized];
  const pricing = modelPricing(normalized);
  if (model && pricing) return { modelId: normalized, ...model, ...pricing };

  return null;
}

/**
 * Look up the total context window (in tokens) for a model. Falls back to
 * 200k when the model isn't in the registry — a safe floor for modern Claude
 * and GPT-class models. Callers use this to render context-usage indicators
 * on the chat composer, so the floor just means the indicator is slightly
 * conservative for unknown models.
 */
export function getAgentModelContextWindow(modelId: string): number {
  return getAgentModelInfo(modelId)?.contextWindow ?? DEFAULT_CONTEXT_WINDOW;
}

const DATED_SNAPSHOT_SUFFIX = /-(?:\d{4}-\d{2}-\d{2}|\d{8})$/;

/**
 * Map the model id a provider reports on its response to a registry id.
 * Providers answer with the snapshot they served — `claude-haiku-4-5-20251001`,
 * `gpt-5.6-luna-2026-08-14`, `gemini-3.8-flash-001` — rather than the name
 * that was requested, so an exact lookup alone would miss most of them.
 * Returns null when nothing in the registry matches.
 */
export function resolveServedModelId(servedModelId: string): string | null {
  const models = AGENT_MODEL_REGISTRY.models as Record<string, unknown>;
  const normalized = normalizeAgentModelId(servedModelId.trim());
  if (models[normalized]) return normalized;
  const undated = normalizeAgentModelId(normalized.replace(DATED_SNAPSHOT_SUFFIX, ""));
  if (models[undated]) return undated;
  let best: string | null = null;
  for (const id of Object.keys(models)) {
    if (normalized.startsWith(`${id}-`) && (best === null || id.length > best.length)) best = id;
  }
  return best;
}

/**
 * The context window of the model that actually answered, falling back to the
 * window of the model the run asked for when the served id is missing or
 * unknown. A tier reference or a fallback chain means the two can differ.
 */
export function getServedModelContextWindow(
  servedModelId: string | null | undefined,
  requestedWindow: number,
): number {
  const resolved = servedModelId ? resolveServedModelId(servedModelId) : null;
  return (resolved ? getAgentModelInfo(resolved)?.contextWindow : undefined) ?? requestedWindow;
}

export function agentModelSupportsWebSearch(modelId: string): boolean {
  const normalized = normalizeAgentModelId(modelId);
  const entry = (AGENT_MODEL_REGISTRY.models as Record<string, { supportsWebSearch?: boolean }>)[
    normalized
  ];
  return entry?.supportsWebSearch === true;
}

/**
 * Models that spend output tokens on reasoning before any text unless told
 * otherwise, and reject sampling parameters such as temperature. Claude models
 * before the 5 generation only think when thinking is requested, so they are not listed.
 */
export function agentModelReasonsByDefault(modelId: string): boolean {
  const normalized = normalizeAgentModelId(modelId);
  const entry = (AGENT_MODEL_REGISTRY.models as Record<string, { reasonsByDefault?: boolean }>)[
    normalized
  ];
  return entry?.reasonsByDefault === true;
}

export function agentModelSupportsComputerUse(modelId: string): boolean {
  const normalized = normalizeAgentModelId(modelId);
  const entry = (AGENT_MODEL_REGISTRY.models as Record<string, { supportsComputerUse?: boolean }>)[
    normalized
  ];
  return entry?.supportsComputerUse === true;
}
